import { render } from "./TotalCurrentLiabilities.vue?vue&type=template&id=5e26b53a&scoped=true"
import script from "./TotalCurrentLiabilities.vue?vue&type=script&lang=js"
export * from "./TotalCurrentLiabilities.vue?vue&type=script&lang=js"

import "./TotalCurrentLiabilities.vue?vue&type=style&index=0&id=5e26b53a&scoped=true&lang=css"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e26b53a"]])

export default __exports__